import React from "react"

import SZITCH from "../images/SZITCH.jpeg"
import SectionHeader from "./section-header"
import { COLORS } from "../styles/constants"

const Content = () => (
  <div style={{ padding: "4rem 1rem", textAlign: "center" }}>
    <SectionHeader
      title="What is SZITCH ?"
      description="A Web Application / Digital Directory for Gamers and future Esports stars to connect 
      , track their skills and monetize their specific gaming skills."
    />
    <content
      style={{
        display: "grid",
        alignItems: "center",
        justifyContent: "center",
        gridTemplateColumns: "repeat(auto-fit, minmax(240px, 340px))",
      }}
    >
      <div>
        <h3>Why SZITCH ?</h3>
        <p style={{ color: COLORS.gray }}>
          Around 15M people stream. But who got the real skills to be the next Star in Gaming. SZITCH will create a gateway for gamers and the future stars in Gaming and Esports to become a PRO with transparent and simple web tools.
        </p>
      </div>
      <div>
        <img src={SZITCH} alt="a blank card floating over colorful graphics" />
      </div>
    </content>
  </div>
)

export default Content
